import _styled from "styled-components";
import React, { useMemo } from "react";
import { ScreenKind } from "./ScreenKind";
import { useRegistersSubscription } from "../../DeviceData/useRegistersSubscription";
import { useRegisterConfigQuery } from "../../DeviceData/useRegisterConfigQuery";

var Container = _styled.div.withConfig({
  displayName: "MenuScreen__Container",
  componentId: "pakjk2-0"
})(["flex:1;display:flex;flex-direction:column;height:0;"]);

var Description = _styled.div.withConfig({
  displayName: "MenuScreen__Description",
  componentId: "pakjk2-1"
})(["text-align:center;margin-top:40px;font-size:24px;"]);

var Button = _styled.button.withConfig({
  displayName: "MenuScreen__Button",
  componentId: "pakjk2-2"
})(["padding:0;background:#4d9ade;color:white;border:0 none;border-radius:10px;height:50px;display:flex;align-items:center;justify-content:center;"]);

var ButtonsContainer = _styled.div.withConfig({
  displayName: "MenuScreen__ButtonsContainer",
  componentId: "pakjk2-3"
})(["margin-top:80px;overflow-y:auto;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"]);

var OneButtonRow = _styled.div.withConfig({
  displayName: "MenuScreen__OneButtonRow",
  componentId: "pakjk2-4"
})(["display:flex;justify-content:center;margin-bottom:32px;", "{width:200px;}"], Button);

var TwoButtonsGrid = _styled.div.withConfig({
  displayName: "MenuScreen__TwoButtonsGrid",
  componentId: "pakjk2-5"
})(["display:flex;justify-content:center;flex-wrap:", ";flex-direction:", ";gap:32px 0;width:380px;margin:0 auto;margin-bottom:32px;@media screen and (max-width:419px){width:340px;}"], function (p) {
  return p.reverse ? "wrap-reverse" : "wrap";
}, function (p) {
  return p.reverse ? "row-reverse" : "reverse";
});

var ButtonCell = _styled.div.withConfig({
  displayName: "MenuScreen__ButtonCell",
  componentId: "pakjk2-6"
})(["flex:0 0 50%;padding:0 10px;box-sizing:border-box;display:flex;justify-content:center;", "{flex:1 0 auto;}"], Button);

var IndicatorsGrid = _styled.div.withConfig({
  displayName: "MenuScreen__IndicatorsGrid",
  componentId: "pakjk2-7"
})(["display:flex;justify-content:center;flex-wrap:wrap-reverse;flex-direction:row-reverse;gap:4px 0;width:380px;margin:0 auto;margin-bottom:32px;@media screen and (max-width:419px){width:340px;}"]);

var IndicatorCell = _styled.div.withConfig({
  displayName: "MenuScreen__IndicatorCell",
  componentId: "pakjk2-8"
})(["flex:0 0 50%;padding:0 10px;box-sizing:border-box;display:flex;justify-content:center;align-items:center;gap:8px;"]);

var Indicator = _styled.div.withConfig({
  displayName: "MenuScreen__Indicator",
  componentId: "pakjk2-9"
})(["--indicator-color:", ";flex:0 0 auto;box-sizing:border-box;width:16px;height:16px;border:2px solid ", ";border-radius:50%;background:", ";"], function (p) {
  return p.kind === "alarm" ? "red" : "skyblue";
}, function (p) {
  return p.active ? "var(--indicator-color)" : "#dddedf";
}, function (p) {
  return p.active ? "var(--indicator-color)" : "transparent";
});

var IndeterminateIndicator = _styled.div.withConfig({
  displayName: "MenuScreen__IndeterminateIndicator",
  componentId: "pakjk2-10"
})(["flex:0 0 auto;box-sizing:border-box;width:16px;height:16px;border-radius:50%;background:#edeeef;"]);

var IndicatorTitle = _styled.div.withConfig({
  displayName: "MenuScreen__IndicatorTitle",
  componentId: "pakjk2-11"
})(["flex:0 1 auto;"]);

export function MenuScreen(_ref) {
  var title = _ref.title,
      setScreen = _ref.setScreen,
      hasDeviceMenu = _ref.hasDeviceMenu,
      serviceMenu = _ref.serviceMenu;
  var hasSpecialScreens = !!serviceMenu && !!(serviceMenu.general || serviceMenu.alarms || serviceMenu.sensors);
  var indicators = serviceMenu && serviceMenu.status && serviceMenu.status.indicators;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Description, null, title || "Сервисное меню"), serviceMenu && /*#__PURE__*/React.createElement(ButtonsContainer, null, indicators && indicators.length > 0 && /*#__PURE__*/React.createElement(IndicatorsSection, {
    indicators: indicators
  }), hasSpecialScreens && /*#__PURE__*/React.createElement(TwoButtonsGrid, {
    reverse: true
  }, serviceMenu.sensors ? /*#__PURE__*/React.createElement(ButtonCell, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setScreen(ScreenKind.Sensors);
    }
  }, "\u0414\u0430\u0442\u0447\u0438\u043A\u0438")) : null, serviceMenu.alarms ? /*#__PURE__*/React.createElement(ButtonCell, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setScreen(ScreenKind.Alarms);
    }
  }, "\u0410\u0432\u0430\u0440\u0438\u0438")) : null, serviceMenu.general ? /*#__PURE__*/React.createElement(ButtonCell, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setScreen(ScreenKind.Control);
    }
  }, "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435")) : null), /*#__PURE__*/React.createElement(TwoButtonsGrid, null, serviceMenu.screens ? serviceMenu.screens.map(function (sectionConfig, idx) {
    return /*#__PURE__*/React.createElement(ButtonCell, {
      key: idx
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setScreen(ScreenKind.Params(idx));
      }
    }, sectionConfig.title));
  }) : null), hasDeviceMenu && /*#__PURE__*/React.createElement(OneButtonRow, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setScreen(ScreenKind.DeviceScreen());
    }
  }, "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E"))));
}

function IndicatorsSection(_ref2) {
  var indicators = _ref2.indicators;
  var allRegisters = useMemo(function () {
    return indicators.map(function (i) {
      return i.register;
    });
  }, [indicators]);

  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registerConfig = useRegisterConfigQuery(allRegisters);

  if (!registerConfig) {
    return null;
  }

  return /*#__PURE__*/React.createElement(IndicatorsGrid, null, indicators.toReversed().map(function (indicator, idx) {
    return /*#__PURE__*/React.createElement(IndicatorCell, {
      key: idx
    }, typeof registersData[indicator.register] === "undefined" ? /*#__PURE__*/React.createElement(IndeterminateIndicator, null) : /*#__PURE__*/React.createElement(Indicator, {
      kind: indicator.kind,
      active: registersData[indicator.register]
    }), /*#__PURE__*/React.createElement(IndicatorTitle, null, indicator.title || registerConfig[indicator.register].title));
  }));
}